import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.page.html',
  styleUrls: ['./booking-details.page.scss'],
})
export class BookingDetailsPage implements OnInit {
  @Input() bookings: any[] = []; // array for workspace / multiple bookings
  expandedAttendees: boolean[] = [];
  constructor(
    private modalController: ModalController, 
  ) {}
  ngOnInit() {
    // Initialize attendees expansion
    this.expandedAttendees = this.bookings.map(() => false);
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
